import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MasterService} from '../../services/master.service';
import {TimezoneModel} from '../../models/timezone.model';

@Component({
  selector: 'lba-select-timezone',
  templateUrl: './select-timezone.component.html',
  styleUrls: ['./select-timezone.component.scss'],
})
export class SelectTimezoneComponent implements OnInit, OnDestroy {

  searchStr: string = '';

  timezones: { offset: number, utc: string, timezone: string }[] = [];

  timezoneName: string = 'Select timezone';

  subscription: Subscription;

  isLoaded: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private masterService: MasterService,
  ) {
  }

  ngOnInit() {
    this.subscription = this.masterService.getTimezones().subscribe((timezones: TimezoneModel[]) => {
      for (const timezone of timezones) {
        for (const utc of timezone.utc) {
          this.timezones.push({offset: timezone.offset, utc: utc, timezone: timezone.text});
        }
      }
      this.isLoaded = true;
    },
      error => {
        console.log(error);
        window.alert('Error: ' + error.message + ', error status: ' + error.status);
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // ngAfterViewInit(): void {
  //   // this.checkParamsValid();
  // }

  closeModal() {
    this.activeModal.close();
  }

  selectTimezone(selectedTimezone: { offset: number, utc: string, timezone: string  }) {
    this.activeModal.close(selectedTimezone.utc);
  }

}

